import React from "react";
import { useUser } from "../../contexts/UserContext";
import { PageStructure } from "../../pages";
import { AddPoolOption, UpdatePoolOption } from "../../components";
import "./PoolSettings.css";

const PoolSettings = () => {
  return (
    <PageStructure>
      <h1>Pool Settings</h1>
      <hr />
      <AddPoolOption />
      <UpdatePoolOption />
    </PageStructure>
  );
};

export default PoolSettings;